export const getErrorMessage = (error) =>
  error?.extensions?.message || 'Failed to Get Data';

/**
 * Guest flow base path constant
 */
export const GUEST_FLOW_BASE_PATH = '/guest-plan-selection';

/**
 * Checks if the current page is part of the guest flow
 * @returns true if user is in guest flow, false otherwise
 */
export const isGuestFlow = (): boolean =>
  window.location.pathname.includes(GUEST_FLOW_BASE_PATH);

/**
 * Formats the top frames of a stack trace for diagnostic logging.
 * Create the Error at the call site so the trace is anchored there.
 * @param error an Error captured where the diagnostic originates
 * @param frameCount how many frames to keep
 */
export const getStackTrace = (error: Error, frameCount = 5): string =>
  (error.stack ?? '')
    .split('\n')
    .slice(1, frameCount + 1)
    .map((frame) => frame.trim())
    .join(' <- ');
